/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class VersionService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get App Version
     * Get the current application version
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAppVersion(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version/api',
        });
    }

}
